import styled from "styled-components";

export const StyledDesktopUserInfo = styled.div`
  display: flex;
  margin: 10px 0 20px 0;
  align-items: center;

  h1,
  h2 {
    margin: 0 0 0 10px !important;
  }

  h2 {
    font-weight: normal;
    font-size: 14px;
    margin: 2px 0 0 10px;
  }
`;

export const StyledMobileUserInfo = styled.div`
  display: flex;
  margin: 10px 0 20px 0;
  padding: 5px;
  align-items: center;

  h1,
  h2 {
    margin: 0 0 0 15px !important;
    font-size: 1.1rem;
  }

  h2 {
    font-weight: normal;
    font-size: 14px;
    margin: 2px 0 0 10px;
  }
`;

export const StyledMobileUserInfoHeader = styled.h1`
  align-items: flex-start;
`;
